import { createRouter,  createWebHashHistory } from 'vue-router'
import home from '../views/home.vue'



const routes = [
  {
    path: '/',
    redirect: '/home/index'
  },
  {
    path: '/home',
    name: 'home',
    component: home,
    children: [
      {
        path: '/home/index',
        name: 'homeIndex',
        component: () => import('@/views/page/index.vue')
      },
      {
        path: '/home/buyData',
        name: 'buyData',
        component: () => import('@/views/page/buyData.vue')
      },
      {
        path: '/home/accountTool',
        name: 'accountTool',
        component: () => import('@/views/page/accountTool.vue')
      },
      {
        path: '/home/onlineTool',
        name: 'onlineTool',
        component: () => import('@/views/page/onlineTool.vue')
      },
      {
        path: '/home/personalCenter',
        name: 'personalCenter',
        component: () => import('@/views/page/personalCenter.vue')
      },
      {
        path: '/home/needData',
        name: 'needData',
        component: () => import('@/views/page/needData.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})


export default router
